import ConversationConnector from 'api/conversation-connector'
import { useSyncExternalStore } from 'preact/compat'
import { useSeamlyApiContext } from './seamly-api-hooks'

const useSeamlyConversation = () => {
  const api = useSeamlyApiContext()

  const getSnapshot = () => api.conversation

  return useSyncExternalStore(ConversationConnector.subscribe, getSnapshot)
}

export default useSeamlyConversation
